import { render, staticRenderFns } from "./DmhArticles.vue?vue&type=template&id=0183f1fa"
import script from "./DmhArticles.vue?vue&type=script&lang=js"
export * from "./DmhArticles.vue?vue&type=script&lang=js"
import style0 from "./DmhArticles.vue?vue&type=style&index=0&id=0183f1fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports